export default __webpack_public_path__ + "static/media/9.1a70b16a.mp3";